import { Icon } from '@fluentui/react';
import styled from 'styled-components/macro';

export const StIcon = styled(Icon)`
    margin-right: var(--space-xxxs);
    /* color: var(--color-contrast-medium); */
`;
